import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IrisService } from '../shared/iris.service';
import { ArticleCard } from '../shared/iris.interface';
import { PageEvent, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-searchedboard',
  templateUrl: './searchedboard.component.html',
  styleUrls: ['./searchedboard.component.scss']
})
export class SearchedBoardComponent implements OnInit {
  articles: ArticleCard[] = [];
  allArticles: ArticleCard[] = [];
  articleCount: number;
  searchType: string;
  options: string[] = [];
  result: string;
  pageIndex = 0;

  overlayRef = this.overlay.create({
    hasBackdrop: true,
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,    
    private translate: TranslateService,
    private irisSrv: IrisService,
    private overlay: Overlay,
    private pageSrv: MatPaginatorIntl,
    private location: Location,
  ) {
    console.log('searchdashboard constructor');
    if (!this.irisSrv.isInit) {
      this.router.navigate(['dashboard']);
    }

    this.pageSrv.nextPageLabel = translate.instant('navigation.next');
    this.pageSrv.previousPageLabel = translate.instant('navigation.previous');
  }

  ngOnInit(): void {
    this.overlayRef.attach(new ComponentPortal(MatSpinner));
    this.route.queryParams.subscribe(params => {
      this.searchType = params['type'];
      this.options = params['options'].split(',');
      this.searchResult();

      // フィルター後の記事一覧を取得
      this.irisSrv.getFilteredArticles(this.searchType, this.options)
        .then(filteredArticle => {
          this.allArticles = filteredArticle;

          // ランダム表示
          if (this.irisSrv.isActiveRoot()) {
            this.irisSrv.shuffle(this.allArticles);
            this.irisSrv.resetRoot();
          } else {
            this.allArticles = this.irisSrv.popArticle();
          }
          this.irisSrv.pushArticle(this.allArticles);

          // ページインデックス処理
          this.pageIndex = this.irisSrv.getIndex();
          let start = this.pageIndex * 5;
          let end = this.pageIndex * 5 + 5;          
          this.articles = this.allArticles.slice(start, end);
          this.articleCount = this.allArticles == null ? 0 : this.allArticles.length;
        })
        .catch(ret => {
          console.log('error')
          console.log(ret)
        })
        .finally(() => {
          this.overlayRef.detach();
        });
    });
  }
  
  searchResult() {
    if (this.options.length && this.options[0] != "") {
      this.result = this.translate.instant(this.options[0]);
      this.result = this.result.replace('\n', '');
      if (this.searchType === 'search.type_info') {
        if (this.options.length > 2) {
          this.result += '...';
        }
      } else {
        if (this.options.length > 1) {
          this.result += '...';
        }
      }
    } else {
      this.result = 'すべて';
    }
  }

  chipStyle(type: string, tag: string) {
    // 検索タグと一致
    if (this.options.includes(tag)) {
      return {
        'background-color': '#ff6464',
        'color': 'white'
      };
    }
  
    // 検索種別
    switch(type) {
    case 'search.type_info':
      return {
        'background-color': '#f8ca6a',
        'color': 'white'
      };
    case 'search.type_voice':
      return {
        'background-color': '#8cd6ef',
        'color': 'white'
      };
    case 'search.type_knowledge':
      return {
        'background-color': '#7ee269',
        'color': 'white'
      };
    default:
      return {
        'background-color': '#7ee269',
        'color': 'white'
      };
    } 
  }

  public goBack() {
    this.location.back();
  }
 
  /**
   * 記事のクリックイベントハンドラー
   * @param key Docmentのキー
   * @param type 検索種別(声/相談先/知恵)
   */
  public onClick(key: string, type: string) {
    if (type === 'search.type_voice') {
      this.router.navigate(['voice'], { queryParams: { key: key } });
    } else if (type === 'search.type_info') {
      this.router.navigate(['facility'], { queryParams: { key: key } });
    }
  }

  public onChipClick(tag: string) {
    this.pageIndex = 0;
    this.irisSrv.resetIndex();
    this.router.navigate(['searchedboard'], { queryParams: { type: 'search.type_article', options: tag } });
  }

 /**
   * ページインジケーターのイベントハンドラー
   * @param evt PageEvent
   */
  public pageEvent(evt: PageEvent){
    this.irisSrv.setIndex(evt.pageIndex);
    let start = evt.pageIndex * 5;
    let end = evt.pageIndex * 5 + 5;
    this.articles = this.allArticles.slice(start, end);
  }
}
